var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-center"},[_c('div',{staticClass:"text-center text-blue-10"},[_c('q-spinner',{staticClass:"q-mb-lg",attrs:{"color":"purple-10","size":"xl"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }